import { cn } from '@/utils/cn'
import React from 'react'

interface ButtonProps extends React.ComponentProps<'button'> {
	children: React.ReactNode
	className?: string
}

export const Button = ({ children, className, ...rest }: ButtonProps) => {
	return (
		<button
			{...rest}
			className={cn(
				'bg-primary hover:border-primary hover:text-primary cursor-pointer rounded-[10px] border border-white px-10 py-2.5 text-lg text-white transition-transform duration-300 hover:scale-105 hover:bg-white',
				className,
			)}>
			{children}
		</button>
	)
}
